module.exports = __webpack_public_path__ + "static/img/mouse.83c1ef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/mouse.png
// module id = 2rtg
// module chunks = 0